// src/api/checkout/placeOrderApi.js
import axios from "axios";
import { SUBSCRIBEURL } from "../index";

export const SubscribePlanApi = (postData) => {
  return axios.post(SUBSCRIBEURL, postData);
};
